"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchCustomEvent = dispatchCustomEvent;
/**
* Dispatches a custom event to the specified event target.
* @param event The custom event to dispatch.
* @param eventTarget The target to dispatch the event to (defaults to window).
*/
function dispatchCustomEvent(event, eventTarget = window) {
  eventTarget.dispatchEvent(event);
}
//# sourceMappingURL=dispatchCustomEvent.js.map